export const ACTIONS_INTERACTIVE = {
  LIKE: 'like',
  DISLIKE: 'dislike',
  COMPLETE: 'complete'
}
